/* import gas from "../../../Assets/Images/questions/questionOne/gas.svg"; */
/* import lpg from "../../../Assets/Images/questions/questionOne/lpg.svg"; */
/* import oil from "../../../Assets/Images/questions/questionOne/oil.svg"; */

export const fuelData = [
  {
    title: "GAS",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642162627/AquaHeat/Quote%20Icons/question%201/gas_pyghyw.svg",
  },
  {
    title: "LPG",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642162627/AquaHeat/Quote%20Icons/question%201/lpg_xmgub3.svg",
  },
  {
    title: "OIL",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642162627/AquaHeat/Quote%20Icons/question%201/oil_iqmz10.svg",
  },
];
